import { combineEpics } from "redux-observable";
import AjaxEpics from "../ajax/epics";
import AboutEpics from "./about/epics";
import IpConfigEpics from "./ipConfig/epics";
import IpConfigOnRebootEpics from "./ipConfigOnReboot/epics";
import alertsRecentEpics from "./alertsRecent/epics";
import unixEpics from "./unix/epics";
import rtcEpics from "./rtc/epics";

const Epics = combineEpics(
  AjaxEpics,
  AboutEpics,
  IpConfigEpics,
  IpConfigOnRebootEpics,
  alertsRecentEpics,
  unixEpics,
  rtcEpics
);

export default Epics;
